/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import { Navigation, Keyboard } from 'swiper/modules';
import { useSwiper } from 'swiper/react';
import HcbswordSlide from "./HcbswordSlide";
import WarpSlide from "./WarpSlide"
import ResetSlide from "./ResetSlide";
import TreasureSlide from "./TreasureSlide";
import MPSlide from "./MPSlide"
import RoseSlide from "./RoseSlide"
import ReverseSlide from "./ReverseSlide";

const ItemExplainSlide = () => {
  const NaviStyle = css`

  .swiper-slide {
    width: 70vw;
    height: 99vh;
    text-align: center;
    font-size: 1.5vw;
    background: #fff;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }

`;

  const swiper = useSwiper();
  return (
    <div css={NaviStyle}>
      <Swiper navigation={true} modules={[Navigation, Keyboard]} className="swiper-slide"
        keyboard={{
          enabled: true,
        }} >
        <SwiperSlide>
          <WarpSlide />
        </SwiperSlide>
        <SwiperSlide>
          <ReverseSlide />
        </SwiperSlide>
        <SwiperSlide>
          <HcbswordSlide />
        </SwiperSlide>
        <SwiperSlide>
          <MPSlide />
        </SwiperSlide>
        <SwiperSlide>
          <ResetSlide />
        </SwiperSlide>
        <SwiperSlide>
          <TreasureSlide />
        </SwiperSlide>
        <SwiperSlide>
          <RoseSlide />
        </SwiperSlide>

      </Swiper>
    </div>
  );
}
export default ItemExplainSlide